// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"269":"fda45de2e23aaf06","924":"cdf3dda4139e0e20"}[chunkId] + ".css";
};